var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M10.186.5H4.314A4.314 4.314 0 0 0 0 4.814v5.872A4.314 4.314 0 0 0 4.314 15h5.872a4.314 4.314 0 0 0 4.314-4.314V4.814A4.314 4.314 0 0 0 10.186.5",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M14.057 2.922 2.834 14.623l-.058.087c.39.156.8.254 1.218.29l4.872-5.075 3.8 3.864a.55.55 0 0 0 .362.16q.304-.274.558-.595a.47.47 0 0 0-.145-.326l-3.82-3.886 4.813-5.017a4.3 4.3 0 0 0-.377-1.203M4.85 2.545a2.64 2.64 0 0 0-2.291 2.254 2.6 2.6 0 0 0 .645 2.088l1.327 1.494a.834.834 0 0 0 1.24 0l1.334-1.494a2.6 2.6 0 0 0 .436-2.81A2.625 2.625 0 0 0 4.85 2.544m.304 3.581a.979.979 0 1 1 0-1.957.979.979 0 0 1 0 1.957"
  })));
};
export default SvgMap;